function o(e) {
  return !e.isZero();
}
export {
  o as parseBoolean
};
//# sourceMappingURL=parseBoolean.js.map
